// tempexp_14978-full-file

export enum SharedTab {
    links = 'links',
    incoming = 'incoming',
    autodelete = 'autodelete',
}
